"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _radio = _interopRequireDefault(require("@kyruus/radio"));
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const RadioButton = exports.RadioButton = /*#__PURE__*/(0, _base.default)(_radio.default, process.env.NODE_ENV === "production" ? {
  target: "e94aob00"
} : {
  target: "e94aob00",
  label: "RadioButton"
})(process.env.NODE_ENV === "production" ? {
  name: "6kn0c0",
  styles: "padding:0;flex-wrap:wrap;>div{justify-content:start;>div{width:8rem;flex-grow:0;}}"
} : {
  name: "6kn0c0",
  styles: "padding:0;flex-wrap:wrap;>div{justify-content:start;>div{width:8rem;flex-grow:0;}}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0d4VWkvQnV0dG9uTGlzdC9zdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3dDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0d4VWkvQnV0dG9uTGlzdC9zdHlsZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUmFkaW8gZnJvbSAnQGt5cnV1cy9yYWRpbyc7XG5cbmV4cG9ydCBjb25zdCBSYWRpb0J1dHRvbiA9IHN0eWxlZChSYWRpbylgXG4gIHBhZGRpbmc6IDA7XG4gIGZsZXgtd3JhcDogd3JhcDtcblxuICA+IGRpdiB7XG4gICAganVzdGlmeS1jb250ZW50OiBzdGFydDtcbiAgICA+IGRpdiB7XG4gICAgICB3aWR0aDogOHJlbTsgLy8gZnJvbSBwbWNcbiAgICAgIGZsZXgtZ3JvdzogMDtcbiAgICB9XG4gIH1cbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});